package com.castly.admin.ui.labels

import androidx.compose.runtime.*
import com.castly.admin.api.ApiClient
import com.castly.admin.ui.theme.AppTheme
import com.castly.admin.ui.theme.Spacing
import com.castly.admin.ui.theme.BorderRadius
import com.castly.shared.dto.CreateLabelUserRequest
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun CreateLabelUserDialog(
    labelId: Int,
    labelName: String,
    apiClient: ApiClient,
    onCreated: () -> Unit,
    onCancel: () -> Unit
) {
    val colors = AppTheme.colors
    val scope = rememberCoroutineScope()
    var email by remember { mutableStateOf("") }
    var creating by remember { mutableStateOf(false) }
    var error by remember { mutableStateOf<String?>(null) }

    Div({
        style {
            padding(Spacing.md)
            backgroundColor(Color(colors.surface))
            borderRadius(BorderRadius.md)
            marginBottom(Spacing.md)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(Spacing.sm)
            border(1.px, LineStyle.Solid, Color(colors.primary))
        }
    }) {
        Div({
            style { fontWeight("600"); fontSize(14.px); color(Color(colors.text)) }
        }) { Text("Create User for $labelName") }

        Div({
            style { fontSize(12.px); color(Color(colors.textMuted)) }
        }) { Text("User will be created with Label Editor role and assigned to this label.") }

        Input(InputType.Email) {
            value(email)
            placeholder("User email address")
            onInput { email = it.value }
            style {
                padding(Spacing.sm)
                borderRadius(BorderRadius.sm)
                border(1.px, LineStyle.Solid, Color(colors.border))
                backgroundColor(Color(colors.background))
                color(Color(colors.text))
                fontSize(14.px)
                width(100.percent)
            }
        }

        if (error != null) {
            Div({ style { color(Color(colors.danger)); fontSize(12.px) } }) { Text(error!!) }
        }

        Div({
            style {
                display(DisplayStyle.Flex)
                gap(Spacing.sm)
            }
        }) {
            Button({
                onClick {
                    if (email.isBlank() || !email.contains("@")) {
                        error = "Please enter a valid email address"
                        return@onClick
                    }
                    scope.launch {
                        creating = true; error = null
                        try {
                            apiClient.createLabelUser(labelId, CreateLabelUserRequest(email = email.trim()))
                            email = ""; onCreated()
                        } catch (e: Exception) { error = e.message ?: "Failed to create user" }
                        creating = false
                    }
                }
                style {
                    padding(Spacing.sm, Spacing.md)
                    backgroundColor(Color(colors.primary))
                    color(Color.white)
                    border(0.px)
                    borderRadius(BorderRadius.md)
                    cursor("pointer")
                    fontSize(13.px)
                }
            }) { Text(if (creating) "Creating..." else "Create User") }

            Button({
                onClick { onCancel() }
                style {
                    padding(Spacing.sm, Spacing.md)
                    backgroundColor(Color("transparent"))
                    color(Color(colors.textMuted))
                    border(1.px, LineStyle.Solid, Color(colors.border))
                    borderRadius(BorderRadius.md)
                    cursor("pointer")
                    fontSize(13.px)
                }
            }) { Text("Cancel") }
        }
    }
}
